import Vue from 'vue'
import Vuex from 'vuex'
import Stomp from "stompjs";
import { studentList } from "@/api/student";
import { userInfo } from "@/api/user";

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isLogin: !!localStorage.getItem('token') || !!sessionStorage.getItem('token'),
    studentList: [],
    update: false,
    stompClient: null,
    myInfo: JSON.parse(localStorage.getItem('myInfo')) || null,
  },
  mutations: {
    SET_LOGIN(state, ctx) {
      state.isLogin = ctx;
    },
    SET_STUDENTS(state, ctx) {
      state.studentList = ctx;
    },
    SET_UPDATE(state, ctx) {
      state.update = ctx;
    },
    SET_STOMPCLIENT(state, ctx) {
      state.stompClient = ctx;
    },
    SET_MYINFO(state, val) {
      state.myInfo = val;
      localStorage.setItem('myInfo', JSON.stringify(val));
    },
    CLEAR_MYINFO(state) {
      state.myInfo = null;
      localStorage.removeItem('myInfo');
    },
  },
  actions: {
    //   用户信息
    getUserInfo(content) {
      userInfo().then((res) => {
        if (res.code == 0) {
          content.commit("SET_MYINFO", res.data);
        } else {
          console.log(res.msg);
        }
      });
    },
    // 班级学生
    getStudents(content, payload) {
      studentList({
        classId: payload.classId
      }).then((res) => {
        if (res.code == 0) {
          content.commit("SET_STUDENTS", res.data);
        } else {
          console.log(res.msg);
        }
      });
    },
    // 连接聊天室
    connectChat(content) {
      const socket = new WebSocket(`${process.env.VUE_APP_WS_DOMAIN}/app/ws`);
      const stompClient = Stomp.over(socket);
      content.commit("SET_STOMPCLIENT", stompClient);
      if (!stompClient.connected) {
        stompClient.connect({
            token: localStorage.getItem("token") || sessionStorage.getItem('token'),
          },
          (frame) => {
            console.log(frame);
          },
          (error) => {
            console.log(error);
          }
        );
      }
    },
    closeChat() {
      this.state.stompClient.ws.onclose();
    }
  },
  modules: {}
})